// english
const en = {
    // 通用
    query: 'Query',
    examine: 'Check',
    btnText: 'LOGIN',
    pleaseInput: 'Please input',
    pleaseChoose: 'Please choose',
    longTermValid: 'long term valid date',
    submit: 'Submit',
    chooseDateTitle: 'Choose Date',
    confirm: 'Confirm',
    close: 'Close',
    longTerm: 'Long term',

    //企业认证
    enterpriseTitle: 'Real-name',
    clickUpload: 'Click to upload',
    businessLicenseInstru: 'Please upload the business license according to the illustration',
    enterpriseTaxNo: 'NIF',
    companyName: 'Company name',
    licenseNo: 'Business License',
    licenseValidDate: 'Business validity',
    businessRegistrationInstru: 'Please upload business registration according to the illustration',
    legalPersonName: "Legal person's name",
    legalPersonLastName: "Legal person's surname",
    legalPersonCardNo: 'Legal person ID',
    legalPersonTaxNo: 'Legal person TaxID',
    bizRegistrationNo: 'Business Registration No',
    legalPersonInstru: "Please upload the front of the legal person's ID,as illustrated by the example",
    legalPersonInstruNegative: "Please upload the reverse side of the legal person's ID,as illustrated by the example",
    signedPersonInstru: "Please upload the front of the signer's ID,as illustrated by the example",
    signedPersonInstruNegative: "Please upload the reverse side of the signer's ID,as illustrated by the example",
    signedPersonTaxNo: "Signer's Tax ID",
    signName:'Name',
    signNamePlaceholder: 'Please enter the name of the signer',
    signCardNo:"Signer's ID",
    signCardNoPlaceholder: "Please enter the signer's ID number",
    signPerson: 'Signer',
    legalPerson: 'Legal Person',
    bizRegistration: 'Business Registration Certificate',
    bizLicense: 'Business License',
    enterpriseInfo:'Enterprise Information',

    //企业认证placeholder
    enterpriseTaxNoPlaceholder: 'Please enter enterprise tax number',
    companyNamePlaceholder: 'Please enter the correct company name',
    licenseNoPlaceholder: 'Please enter the business license number',
    licenseValidDatePlaceholder: 'Please select a business validity period',
    legalPersonNamePlaceholder: "Please enter the legal person's name",
    legalPersonLastNamePlaceholder: "Please enter the legal person's surname",
    legalPersonCardNoPlaceholder: 'Please enter the legal person certificate number',
    legalPersonTaxNoPlaceholder: 'Please enter the legal person tax ID',
    signedPersonTaxNoPlaceholder: "Please enter the signer's tax ID",
    bizRegistrationNoPlaceholder:'Please enter business registration number',

    //结果页
    submited: 'Submited！',
    resultTitle: 'The results page',
    notVerify: 'Not Verified',
    waitingAudit: 'Pending review',
    success: 'Successful verification',
    failed: 'Verified failed',
    gotoVerify: 'Recertification',

    //商家二维码
    principleDetail:"Rule details",
    download:"Download",
    obtainAppFree:"Get the app now for free",
    paypayProfile:"paypay, a professional payment platform, helps cashless life scenarios. Please download from the Android Play Store and Apple App Store.",
    paypayInstru:"Merchant QR code is one of the payment collection service carriers authorized by paypay to use by third-party merchants. It is convenient for merchants to collect fees and manage their own accounts through the paypay platform to achieve a cashless state. The function and maintenance authority of the QR code belong to paypay, and the use right belongs to the authorized merchant. In addition, the transaction records generated after the QR code is bound are counted from the time the QR code is bound. Past records cannot be checked. After unbinding, the transaction records would disappear. Re-binding cannot revive the records. Please be careful to unbind. The specific steps are as follows:", 
    bindQrCode:"Bind QR code",
    unbindQrCode:"Unbind QR code",
    searchTransactionRecord:"Query transaction record",
    //帮助
    registration: 'Sign up',
    realName: 'Real name',
    bindCard: 'Bind bank card',
    recharge: 'Top up',
    transfer: 'Transfer',
    withdrawl: 'Withdrawal',
    registrationContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">How to sign up?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong>Individual：</strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. After opening paypay, click the sign up] button in the upper right corner of the homepage to enter the individual user registration process.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. Select the first [Personal Account] on the interface for selecting the user type, and click the [Next] button.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. Register account page, enter the mobile number and SMS verification code. In addition, the mobile phone number requires 9 digits.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. On the password setting page, you need to set the login password and repeat the login password, and click the [Done] button. Login password requirements: combination of 8-16 digits + letter.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">5. After that, you will see the successful registration page.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong>Enterprise：</strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. After opening paypay, click the [Sign up] button in the upper right corner of the homepage to enter the enterprise user registration process.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. Select the second [Corporate Account] on the interface for selecting the user type, and click the [Next] button.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. On the account registration page, enter the email and email verification code. In addition, the mailbox needs to follow the standardized mailbox format xxx@xxx.xxx</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. On the password setting page, you need to set the login password and repeat the login password, and click the [Done] button. Login password requirements: combination of 8-16 digits + letter.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><span style="font-size:10.5ptpx">After that, you will see the successful registration page.</span></p>',
    realNameContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">How to real name verification?</span></strong></p><p></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">Individual：</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. After successful login, the Paypay homepage will prompt for real-name authentication. Click [Go to verify] to enter the real name authentication process</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. First, you need to enter your NIF for verification: click [NEXT] after the input is complete</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. When your tax number is verified, the page will display part of your name, you need to complete the name (full name), and then click [DONE]</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. You will see the page for real-name authentication successful.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong>Enterprise：</strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. After successful registration, return to the home page, enter the registered user name and password, and click the [Login] button</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. After successful login, the paypay homepage will prompt you to authenticate, click [Go verify] to start the enterprise authentication process</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. Enterprise related information: company name, enterprise tax number, business license number, business validity period</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. Legal person information: merchant registration certificate, legal person name, legal person certificate number, legal person tax number</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">5. Information about the signer: name of the signer, tax number of the signer, and certificate number of the signer.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><span style="font-size:10.5ptpx">Merchant registration related information: Merchant registration certificate</span></p>',
    bindCardContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">How to bind bank card?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. Click [Me]-[Bank Card] to enter the bank card binding process, and click the [Add Bank Card] button on the bank card binding page</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. Add a bank card page, you need to enter the bank card number, click [Next] to verify the bank card information; [supported banks] can see which banks are supported</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. When you enter the bank card and click Next, the bank card verification page will automatically obtain the cardholder&#x27;s identity information and bank card information. You need to fill in the [bank card reserved mobile phone number] and click [send verification code] to proceed to the bank card verification</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><span style="font-size:10.5ptpx">After obtaining the verification code, enter the verification code and click Next. After the verification code is verified, your card is successfully tied</span></p>',
    rechargeContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">How to top up?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. If you have completed the real-name authentication and set the payment password, you can log in to the Paypay homepage and click the [Top Up] button to top up your balance. Then enter the top up amount in the top up page.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. After entering the amount, you need to select the card to be paid and click the [Pay] button. The process of binding a bank card is as we talked about in the second part, or you can also click here to add a bank card to bind.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. After selecting the bank card, you need to enter the payment password and receive the SMS verification code. You need to ensure that the payment passwordand SMS verification code are correct, and then click the [Confirm] button.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><span style="font-size:10.5ptpx">You can top up successfully through the above operations. This is the interface for successful top up. After the top up is successful, you can also go to [Me]-[Account Balance] to check your balance.</span></p>',
    transferContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">How to transfer?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. If you have completed the real-name authentication and set the payment password, you can log in to the Paypay homepage and click the [Transfer] button to enter the transfer process.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. You need to enter the account number of the person you want to transfer on the page on the right, click Next and then enter the amount you want to transfer, so that you can start the transfer</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. After entering the amount, you need to select the payment method for the transfer. The payment method can be the balance or the bank card you bound. It should be noted that only the deposit card can be used to transfer money.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><span style="font-size:10.5ptpx">The same as the top up, you must enter the payment password. If you choose to pay by bank card, then you still have to enter the mobile phone verification code; if you use the balance to pay, then you only need to enter the payment password</span></p>',
    withdrawlContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">How to withdrawal?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. If you have enough money in your account balance, and you want to transfer the money from your account to a bank card, then you can use the [withdrawal] function in the right picture. After clicking [Withdrawal] on the homepage, you can start the withdrawal process</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. You need to enter the amount you want to withdraw on the withdrawal page. Please note that the amount cannot be greater than the available balance, and the bank will also limit the amount of each withdrawal.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. After entering the amount, you need to select which bank card you want to withdraw money to. It should be noted that you can only withdraw cash into the deposit card. If you do not want to withdraw cash into the previously bound bank card, you can also add a new bank card to the bank card list for cash withdrawal.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><span style="font-size:10.5ptpx">After selecting the bank card, after you enter the payment password, the withdrawal is successful. It should be noted that the money may not reach your bank card in real time, it is determined by the bank&#x27;s processing results, so there may be a certain delay in the withdrawal of cash to the account.</span></p>',
    slogan:"Inclusive and Convenient",
    privatePolicy:"Private policy",
    serviceAgreement:"Service agreement",
    openPaypay:"Open PAYPAY",
    downloadPaypay:"Download PAYPAY",

    companyShortName:"Company abbreviation",
    basicInfo:"Basic info",
    copies:"Photocopies",
    companyShortNameRequired:"Please enter company abbreviation",
    phoneNumber:"Tel",
    phoneNumberRequired:"Please enter telphone number",
    emailRequired:"Please enter Email",
    companyAddress:"Address of company",
    companyAddressRequired:"Please enter address of company",
    areaOfBusiness:"Area of business",
    bizAreaRequired:"Please choose area of business",
    companyNifPicInstru:"Please follow the example to upload your corporate NIF photo",
    personalIdPicInstru:"Please follow the example and upload your ID front photo",
    personalIdBackPicInstru:"Please follow the example and upload your ID back photo",
    commercialCertPicInstru:"Please follow the example to upload a photo or pdf file of your business registration certificate",
    commercialCertPicInstruPdf:"Please follow the legend to upload your merchant registration certificate (Pdf file)",

     //商户列表
    merchantListTitle:"Merchant list",
    staffListTitle:"Staff management",
    staffDetailTitle:"Staff detail",
    reject:"Reject",
    agree:"Agree",
    deleted:"Deleted",
    all:"All",
    today:"Today",
    latestWeek:"Latest week",
    latestMonth:"Latest month",
    diyDate:"Custom date",
    totalRevenue:"Total revenue",
    count:"Count",
    refund:"Refund",
    fee:"Fee",
    chooseClerk:"Choose staff",
    clerk:"Staff",
    clerkInputPlaceholder:"Enter staff name",
    addClerk:"Add staff",
    addStaffTitle:"Scan by PayPay to become staff",
    clerkList:"Staff list",
    qrcodeRefreshTime:"QR code will refresh every two minutes",
    sts:"Status",
    qrCode:"QR code",
    phoneNumber:"Tel",
    name:"Name",
    del:"Delete",
    contactMethod:"Contact method",
    addSuccess:"Add success",
    normal:"Normal",
    statisticalAnalysis:"Income analysis",
    qrcodeScanInstru:"Note: Please update PayPay to latest version",

    pdfFile:"Pdf File",
    picture:"Photo",
    realNameVerify:"Real-name authentication",
    gender:"Gender",
    birthday:"Birthday",
    province:"Province",
    city:"City",
    personNIF:"NIF",
    next:"Next step",
    provincePlaceholder:"Province(required)",
    cityPlaceholder:"City(required)",

    num:"Serial number",
    tradeVoucherNo:"Consumption certificate number",
    abnormal:"Abnormal",
    refundSuccessForCashback:"Successful refund of cashback",
    refundFailedForCashback:"Failed refund of cashback",
    refundAbnormalForCashback:"Abnormal refund of cashback",
    cashbackPolicyId:"Cashback policy ID",
    refundVoucherNo:"Associated refund number",
    consumerAmount:"Consumption amount",
    cashbackAmount:"Cashback amount",
    contributeAccountNo:"Payment account",
    benefitedMemberId:"Beneficiary member ID",
    benefitedAccountNo:"Beneficiary account",
    transactionNo:"Transaction number",
    refundTransactionNo:"Refund transaction number",
    strategyName:"Policy name",
    benefitedPartyRole:"Beneficiary role",
    cashbackRatio:"Cashback ratio",
    cashbackAmountRange:"Cashback amount range",
    minPaymentAmount:"Threshold amount",
    statisticsDetail:"Statistics field",
    benefitedStatisticsAmountLimit:"Beneficiary cashback amount limit",
    benefitedStatisticsCountLimit:"Beneficiary cashback count limit",
    bizStatisticsAmountLimit:"Accumulated cashback amount of business",
    bizStatisticsCountLimit:"Accumulated cashback count of business",
    specificMember:"Specific member",
    cashbackWithRatio:"Cashback in proportion to transaction amount",
    cashbackWithRandom:"Random cashback",
    day:"Day",
    minCashbackAmount:"Minimum cashback amount",
    maxCashbackAmount:"Maximum cashback amount",
    cashbackDetail:"Cashback detail",
    cashbackReason:"Cashback reason",
    createTime:"Creation time",
    sts:"Status",
    cashbackRecord:'Cashback Record',
    cashbackAnouncement:'Cashback Anouncement',
    cashbackTotalAmount:'Total cashback',
    displayName:'Display name',
    modifyDisName:'Modify name',
    displayNameRequired:'Display name required',

    //消费立减
    reductionType:"Discount type",
    randomReduction:"Random discount",
    deductionReduction:"pay with cashback amount",
    reductionStretegy:"Discountstrategy",
    startAmount:"minimum purchase amount for random discount",
    reductionRange:"discount amount range",
    minReductionAmount:"Minimum discount amount",
    maxReductionAmount:"Maximum discount amount",
    statisticsType:"Statistic type",
    noLimit:"No limit",
    personalAccumulationAmount:"Based on personal accumulation amount",
    personalAccumulationCount:"Based on personal accumulation order quantity",
    personalAndBizAccumulationAmount:"Based on accumulation amount of person and current activity",
    personalAndBizAccumulationCount:"Based on personal accumulation order quantity of person and current activity",
    accumulationLimit:"Personal accumulation amount limit",
    accumulationActivityLimit:"Activity accumulation amount limit",
    reductionRatio:"Discount ratio",
    tradeDirection:"Transaction type",
    revenue:"Income",
    expenditure:"Expenditure",
    reductionType:"Type",
    tradeNo:"Transaction order number",
    amountBeforeTrade:"Balance before the transaction",
    amountAfterTrade:"Balance after the transaction",
    fundDetail:"Fund breakdown",
    txnTradeAmount:"Associated transaction amount",
    txnTradeProductDesc:"Associated commodity",
    txnTradeSellerName:"Associated seller",
    txnTradeCreate:"Transaction time",
    balance:"Balance",
    txnTradeVoucherNo:"Associated transaction number",
    txnTradeGmtCreate:"Associated transaction time",
    tradeAmount:"Transaction amount",
    availableBalance:"Available balance: ",
    freezeBalance:"Freeze balance: ",
    historyCashback:"Total historical cashback amount: ",
    biz_purpose: "Business Purpose",

    input_his_account: "Please enter the phone number of the person to invite",
    wait_handle: "Pending list",
    send: 'Send',
    sent: 'Enviado com sucesso',
    sendAll: 'Send all',
    noDataSend: 'No record sent',
    manualInvite: 'Manual invitation',
    qrcodeInvite: 'QR code invitation',
    inviteTips: '{0} invites you to become their assistant. If you accept, you will assist them in collecting payments. Do you agree?',
    addStaffTitle2: 'Enter user\'s phone or email, invite the user',
    isExists: 'Already exists',
    addTooMuch: "Sending too much at once",

    please_select_store: 'Please select a store',
    all_store: 'All stores',
    all_staff: 'All staff',
    store: 'Store',
    other_store: 'No store',
    no_staff: 'No Staff',

    you_can_not_change_store: "The clerk has been assigned a store and cannot modify it.",
    are_you_sure: "Are you sure?",

    work_day: 'Business hours',
    work_day_all: 'Mon～Sun',
    work_day_a: 'Mon～Fri',
    work_day_1: "Mon",
    work_day_2: "Tue",
    work_day_3: "Wed",
    work_day_4: "Thur",
    work_day_5: "Fri",
    work_day_6: "Sat",
    work_day_7: "Sun",
    store_address: "Business location",
    store_desc: 'Shop description',
    store_group: "Package contents",
    available_date: "Expiration date",
    unlimited_date: "Extended period",
    share_store: 'Share Store',//
    open_with_paypay: 'Open using PayPay',//
    open_tips: 'Using PayPay for payment is more convenient',//
    opening: 'Opening PayPay...',
    open_fail: 'Failed to open PayPay', //
    open_fail_tips: 'Você ainda não instalou o PayPay, gostaria de baixá-lo agora?', //
    coupon_type_1: "Storewide discount of {0}",
    coupon_type_2: "Spend{0}, get {1} off",
    coupon_type_4: "{0}% off",
    share_group: "Share purchase group",//
    group_content: "Package contents",
    target_user_1: 'Effective for all customers',
    target_user_2: 'Exclusive for new customers',
    target_user_3: 'Special for loyal customers',
    claim_with_paypay: 'Open PayPay to receive discount coupons',
    wechat_open_tips: "Unable to open the app in WeChat. You can click on the three dots here in WeChat and use the system's default browser to open, and then try again.",
    share_error_tips: "Sorry, the information shared by the user has expired",
    auto_coupon_txt: "Spend {0}KZ or more({1}), receive a discount coupon: '{2}'",
    auto_coupon_type_1: "Before Discount",
    auto_coupon_type_2: "Actual Payment",
    share_coupon: "Share discount coupon",
    share_paypay: "PayPay sharing",
    clerk_order_permission: "Allow to view all order records",
    operate_success: "Successful operation",
    operate_fail: "Failed operation",
    my_order_analysis: "My Orders",

    lucky: 'Lottery',
    winning_record: 'Record',
    no_active: 'This lottery event has ended',
    no_active_tips: 'Please look forward to the next event.',
    luckyCount: "Times",
    winnerText: "Congratulations to the user {0} for winning {1}",
    no_prize: 'No prize',
    start: 'Start the lottery',
    win_text: 'Congratulations, you win: {0}',
    no_win_text: 'Sorry, get no prize',
    no_luck_draw_count: 'Lottery draw times have been consumed',
    lucky_rule: 'Lottery rules',
    rule_tips: "Note: Please see below for the lottery rules",
    lucky_product: 'Activity name',
    lucky_product_rule: 'Activity Rule',
    lucky_product_time: 'Activity Time',
    lucky_product_entry: 'Entry',
    lucky_users_tips: 'This activity only supports individual users.',
    lucky_owner: '*PayPay reserves the right to interpret this activity*',
    lucky_wait: 'Please look forward to it',
    lucky_recharge: 'Recharge ',
    lucky_buy: 'Consume',
    lucky_has_end: 'Ended',
    reward_tips: 'The prize will be sent to your cashback account within 2 hours, please check it carefully.',
    no_reward: 'No Record ',
    back_to: 'Continue lottery draw',
    cashback_amount: 'Cashback Amount:{0} kz',
    wait_reward: 'Wait for Sending',
    reward_success: 'Successfully Sent',
    reward_fail: 'cashback sending',
    thankyou: 'No prize',

    cashbackTips: 'The cashback balance can be used  in the Business district',
    winnerList: 'Winners List',
    expand: 'Expand',
    collapse: 'Collapse',
    no_winner: 'No winners list yet',
    view: 'View',
    winner_title: 'List of Prize Winners (Last 20)'
}

export default en;


// WEBPACK FOOTER //
// ./src/resource/en.us.js